import React from "react";
import { Card, Col } from "react-bootstrap";
import { EventsPill, populateEventPills } from "./commom/EventsPill";
import { FormattedEventDate, RegisterButton, Speakers, WatchButton } from "./EventsPanelParts";

export default function ArchiveEventCard(props) {
  const pillData = populateEventPills({ ...props, excludeLanguages: true });
  return (
    <Col className="px-2 pb-3 d-flex" lg="4" sm="6" xs="12">
      <Card className="shadow w-100">
        <Card.Header className="border-0">
          <Speakers speakers={props.slots?.[0]?.speakers} />
        </Card.Header>
        <Card.Body>
          <Card.Title className="font-weight-lighter h4-imp my-0">{props.eventName}</Card.Title>
        </Card.Body>
        <Card.Footer className="border-top-0 pb-0 mt-1 mr-3">
          <EventsPill pills={pillData} />
        </Card.Footer>
        <Card.Footer className="border-top-0  align-items-baseline">
          <Card.Text className="h6 mb-1 mr-2">
            <FormattedEventDate {...props} displayTime={false} />
          </Card.Text>
        </Card.Footer>
        <Card.Footer className="clearfix border-1">
          {props.isFutureEvent ? <RegisterButton event={props} /> : <WatchButton {...props} />}
        </Card.Footer>
      </Card>
    </Col>
  );
}
